import React from 'react';

const styles = {
    inner: {
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 3,
        textOverflow: 'ellipsis',
        overflowY: 'hidden'
    }
};

export const HighlightedText = ({children: text, highlightColor='black', style, clamp=true}) =>
    <div style={style} role="none">
        <span role="text" style={{font: 'inherit', fontSize: 'inherit', textShadow: `${highlightColor} 1px 0 5px`, ...clamp ? styles.inner : {}}}>
            {text}
        </span>
    </div>;

HighlightedText.displayName = 'HighlightedText';

export default HighlightedText;

